/** Stable, inexpensive hashing for visual identity and cache keys. */
export function fnv1a32(input: string, seed = 0x811c9dc5, multiplier = 0x01000193): number {
  let hash = seed >>> 0;
  for (let index = 0; index < input.length; index += 1) {
    hash ^= input.charCodeAt(index);
    hash = Math.imul(hash, multiplier) >>> 0;
  }
  return hash >>> 0;
}
